export const SET_PLAYLISTS = 'PLAYLISTS/SET_PLAYLISTS'
